<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { type BadgeVariants, badgeVariants } from '.'
import { cn } from '@/util/shad'

const props = defineProps<{
  variant?: BadgeVariants['variant']
  class?: HTMLAttributes['class']
  style?: HTMLAttributes['style']
}>()
</script>

<template>
  <div
    :class="cn(badgeVariants({ variant }), props.class)"
    :style="props.style"
  >
    <slot />
  </div>
</template>
